// --------------- TYPES ---------------
import { GetInfluencers, GetInfluencer, ChangeInfluencerStatus } from '../Types'

// --------------- ACTIONS ---------------

export const getInfluencers = {
  Request: (params) => ({
    type: GetInfluencers.REQUEST,
    params,
  }),
  Success: (data) => ({
    type: GetInfluencers.SUCCESS,
    payload: data,
  }),
  Failed: (error) => ({
    type: GetInfluencers.FAILED,
    payload: error,
  }),
}

export const getInfluencer = {
  Request: (params) => ({
    type: GetInfluencer.REQUEST,
    params,
  }),
  Success: (data) => ({
    type: GetInfluencer.SUCCESS,
    payload: data,
  }),
  Failed: (error) => ({
    type: GetInfluencer.FAILED,
    payload: error,
  }),
}

export const changeInfluencerStatus = {
  Request: (params) => ({
    type: ChangeInfluencerStatus.REQUEST,
    params,
  }),
  Success: (data) => ({
    type: ChangeInfluencerStatus.SUCCESS,
    payload: data,
  }),
  Failed: (error) => ({
    type: ChangeInfluencerStatus.FAILED,
    payload: error,
  }),
}
